import { isFunction as r } from "../index.js";
import { camelize as e } from "../format/string.js";
import { SlotsMixin as m } from "../../mixins/slots.js";
import "vue";
function s(o) {
  var n = this.name;
  o.component(n, this), o.component(e("-" + n), this);
}
function u(o) {
  var n = o.scopedSlots || o.data.scopedSlots || {},
    i = o.slots();
  return Object.keys(i).forEach(function (t) {
    n[t] || (n[t] = function () {
      return i[t];
    });
  }), n;
}
function p(o) {
  return {
    functional: !0,
    props: o.props,
    model: o.model,
    render: function render(i, t) {
      return o(i, t.props, u(t), t);
    }
  };
}
function d(o) {
  return function (n) {
    return r(n) && (n = p(n)), n.functional || (n.mixins = n.mixins || [], n.mixins.push(m)), n.name = o, n.install = s, n;
  };
}
export { d as createComponent, u as unifySlots };
